import { defineComponent as w, ref as I, computed as u, inject as $, openBlock as t, createElementBlock as o, normalizeClass as E, createElementVNode as l, createVNode as m, unref as a, renderSlot as L, createCommentVNode as c, Fragment as p, renderList as f, toDisplayString as N } from "vue";
import { FeedbackIcon as V } from "./feedbackIcon.es.js";
import { E as z } from "./chunks/EnumParser.dab943ef.js";
import { _ as F, a as B } from "./chunks/CustomLink.vue_vue_type_style_index_0_lang.c7d27b7c.js";
import { F as S } from "./chunks/FrontiersIcon.fac4da01.js";
import './assets/index25.css';var d = /* @__PURE__ */ ((s) => (s.Success = "success", s.Warning = "warning", s.Info = "info", s.Error = "error", s))(d || {});
const b = { class: "Alert__icon" }, H = { class: "Alert__main" }, M = ["innerHTML"], j = { class: "Alert__info" }, x = { class: "Alert__infoItem__text" }, D = {
  key: 0,
  class: "Alert__infoItem__links"
}, q = /* @__PURE__ */ w({
  __name: "Alert",
  props: {
    type: {},
    message: {},
    showClose: { type: Boolean, default: !1 },
    infoItems: { default: () => [] }
  },
  setup(s) {
    const i = s, _ = I(!0), h = u(() => {
      const e = "Alert", n = [e], r = z.getValue(d, i.type);
      return n.push(`${e}--${r}`), i.infoItems.length || n.push(`${e}--noInfo`), i.showClose && n.push(`${e}--showClose`), n;
    }), g = u(() => i.type.toLowerCase()), k = () => {
      _.value = !1;
    }, y = $("sanitize");
    return (e, n) => _.value ? (t(), o("div", {
      key: 0,
      class: E(h.value)
    }, [
      l("div", b, [
        m(a(V), {
          type: g.value,
          size: "lg",
          color: "white"
        }, null, 8, ["type"])
      ]),
      l("div", H, [
        l("p", {
          class: "Alert__message",
          innerHTML: a(y)(e.message)
        }, null, 8, M),
        L(e.$slots, "titleActions"),
        e.showClose ? (t(), o("button", {
          key: 0,
          class: "Alert__message__close",
          onClick: k
        })) : c("", !0)
      ]),
      l("ol", j, [
        (t(!0), o(p, null, f(e.infoItems, (r, A) => (t(), o("li", {
          key: A,
          class: "Alert__infoItem"
        }, [
          l("p", x, N(r.text), 1),
          r.links.length ? (t(), o("ol", D, [
            (t(!0), o(p, null, f(r.links, (C, v) => (t(), o("li", { key: v }, [
              m(a(F), {
                link: C,
                icon: a(S).ChevronRight,
                color: a(B).Grey
              }, null, 8, ["link", "icon", "color"])
            ]))), 128))
          ])) : c("", !0)
        ]))), 128))
      ])
    ], 2)) : c("", !0);
  }
});
export {
  q as Alert,
  d as AlertType
};
